import React, { FC } from 'react';
import { Breadcrumbs } from '@digdir/designsystemet-react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  BreadcrumbsWrapper,
  MainContentWrapper,
  PageLayout
} from '../../../registrationV2025/components/styledComponents';
import { PageLoader } from '../../../registrationV2025/components/pageLoader';
import { useBuildingData } from '../../../../hooks/useBuildingDetails/buildingDetailsHooks';
import { GetEnergiObjektTypeFromMatrikkel } from '../../../../utils/matrikkelBygningsTyper';

import { TiltakForm } from './form';
import { TiltakFormData } from './form/types';
import { useAddTiltak } from './hooks/useAddTiltak';
import { formDataToTiltak } from './utils';

export const NewTiltakForm: FC = () => {
  const { energiplanId } = useParams<{ energiplanId: string }>();

  const { buildingId } = useParams<{ buildingId: string }>();
  const { building, buildingLoading } = useBuildingData(buildingId);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const energiobjekttype = GetEnergiObjektTypeFromMatrikkel(building?.kanEnergimerkesAvPrivatPerson || false);

  const { addTiltak, isLoading } = useAddTiltak(energiplanId);

  const onSubmit = (formData: TiltakFormData) => {
    const tiltak = formDataToTiltak(formData);
    addTiltak(tiltak, {
      onSuccess: () => navigate('../')
    });
  };

  if (buildingLoading || isLoading) {
    return <PageLoader />;
  }

  return (
      <PageLayout>
        <BreadcrumbsWrapper>
          <Breadcrumbs>
            <Breadcrumbs.Link asChild aria-label={t('screens.energiplan.components.tiltakForm.index.backLink')}>
              <Link to="../">{t('screens.energiplan.components.tiltakForm.index.backLink')}</Link>
            </Breadcrumbs.Link>
          </Breadcrumbs>
        </BreadcrumbsWrapper>
        <MainContentWrapper>
          <TiltakForm onSubmit={onSubmit} energiobjekttype={energiobjekttype} />
        </MainContentWrapper>
      </PageLayout>
  );
};
